import {afterRenderEffect, Injectable} from '@angular/core';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

@Injectable({
  providedIn: 'root'
})
export class GtmService {

  constructor() {
    afterRenderEffect(() => {
      if (window.dataLayer) {
        // resolve();
        return;
      }
      const gtmId = 'GTM-MQGR84P7'; // Replace with your GTM ID
      // Create the script element
      const script = document.createElement('script');
      script.defer = true;
      script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
      // Add the script to the head
      document.head.appendChild(script);

      // Data Layer
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
      });

      //Noscript for body
      const noscript = document.createElement('noscript');
      const iframe: any = document.createElement('iframe');
      iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
      iframe.height = 0;
      iframe.width = 0;
      iframe.style.display = 'none';
      iframe.style.visibility = 'hidden';
      noscript.appendChild(iframe);
      document.body.insertBefore(noscript, document.body.firstChild);

      script.onload = () => {
        // resolve();
      };
      script.onerror = () => {
        console.error('Failed to load GTM script.');
        // resolve(); // Resolve even on error to avoid blocking app initialization
      };
    });
  }
  initializeGtm() {}
}
